(function(){
  function init(scope){
    var root=(scope||document).querySelector('.lhl');
    if(!root||root.dataset.lhlReady==='1')return;
    root.dataset.lhlReady='1';
    var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    root.classList.add('lhl-js');

    var rev=root.querySelectorAll('[data-reveal]');
    var showAll=function(){ Array.prototype.forEach.call(rev,function(el){el.classList.add('is-in');}); };
    if(window.IntersectionObserver&&!reduce){
      var io=new IntersectionObserver(function(entries){
        entries.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target); } });
      },{rootMargin:'0px 0px -8% 0px',threshold:0.04});
      Array.prototype.forEach.call(rev,function(el){io.observe(el);});
      var sweep=function(){
        var vh=window.innerHeight||0;
        Array.prototype.forEach.call(rev,function(el){
          if(el.classList.contains('is-in'))return;
          var r=el.getBoundingClientRect();
          if(vh===0||r.top<vh*1.35){ el.classList.add('is-in'); }
        });
      };
      setTimeout(sweep,900); setTimeout(sweep,2200); setTimeout(showAll,6000);
      window.addEventListener('resize',sweep,{passive:true});
    } else { showAll(); }

    var slides=root.querySelectorAll('.lhl-hero-slide');
    if(slides.length>1&&!reduce){
      var i=0;
      setInterval(function(){
        slides[i].classList.remove('is-on');
        i=(i+1)%slides.length;
        slides[i].classList.add('is-on');
      },5600);
    }

    var cds=root.querySelectorAll('[data-countdown]');
    Array.prototype.forEach.call(cds,function(cd){
      var raw=cd.getAttribute('data-countdown');
      var target=Date.parse(raw);
      if(isNaN(target)){ cd.style.display='none'; return; }
      var cells=cd.querySelectorAll('[data-cd]');
      var done=cd.getAttribute('data-done')||'';
      var pad=function(n){ return (n<10?'0':'')+n; };
      var tick=function(){
        var diff=target-Date.now();
        if(diff<=0){
          if(done){ cd.innerHTML='<p class="lhm-cd-done">'+done+'</p>'; }
          else { cd.style.display='none'; }
          clearInterval(timer);
          return;
        }
        var v={ d:Math.floor(diff/86400000), h:Math.floor(diff%86400000/3600000), m:Math.floor(diff%3600000/60000), s:Math.floor(diff%60000/1000) };
        Array.prototype.forEach.call(cells,function(el){ el.textContent=pad(v[el.getAttribute('data-cd')]); });
      };
      tick();
      var timer=setInterval(tick,1000);
    });

    var px=root.querySelectorAll('[data-parallax]');
    if(px.length&&!reduce){
      var ticking=false;
      var update=function(){
        var vh=window.innerHeight;
        Array.prototype.forEach.call(px,function(el){
          var r=el.getBoundingClientRect();
          if(r.bottom<-240||r.top>vh+240)return;
          var sp=parseFloat(el.getAttribute('data-parallax'))||0.1;
          var mid=r.top+r.height/2-vh/2;
          el.style.transform='translate3d(0,'+(-mid*sp).toFixed(1)+'px,0)';
        });
        ticking=false;
      };
      window.addEventListener('scroll',function(){ if(!ticking){ ticking=true; requestAnimationFrame(update); } },{passive:true});
      window.addEventListener('resize',update,{passive:true});
      update();
    }
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',function(){init();});}else{init();}
  document.addEventListener('shopify:section:load',function(e){ if(e.target){ var r=e.target.querySelector('.lhl'); if(r){ r.dataset.lhlReady=''; } init(e.target); } });
})();